import { render } from "./EntregasFreteView.vue?vue&type=template&id=1ce62dd8&scoped=true"
import script from "./EntregasFreteView.vue?vue&type=script&lang=js"
export * from "./EntregasFreteView.vue?vue&type=script&lang=js"

import "./EntregasFreteView.vue?vue&type=style&index=0&id=1ce62dd8&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce62dd8"]])

export default __exports__